import classNames from 'classnames';
import React, { forwardRef, Ref } from 'react';
import { Link, LinkProps, useMatch } from 'react-router-dom';
import { UDTextType } from '../text';

export type IUDNavLinkProps = {
  type?: UDTextType;
  disabled?: boolean;
  checkPath?: string;
  /**
   * Активность, заданная вызывающим. Без него ссылка активна, когда адрес совпал с `checkPath`;
   * `false` гасит её и при совпадении — когда паттерн шире, чем раздел (`/manager/*` и `/manager/queue`).
   */
  active?: boolean;
  variant?: 'primary' | 'secondary';
} & LinkProps;

/**
 * Ссылка меню. `Link`, а не `NavLink`: `NavLink` ставит `aria-current="page"` по совпадению своего `to`
 * и переопределить это нельзя, а у платных пунктов меню без фичи `to` у всех один — вкладка «Подписка»,
 * и «текущих страниц» в навигации становилось несколько. Здесь `aria-current` и класс `active` берутся
 * из одного расчёта.
 */
const UDNavLink = forwardRef<HTMLAnchorElement, IUDNavLinkProps>((props: IUDNavLinkProps, ref: Ref<HTMLAnchorElement>) => {
  const { type = 'callout', disabled, className, checkPath, active, variant = 'primary', ...otherProps } = props;

  const { to } = otherProps;
  const url = checkPath ?? (typeof to === 'string' ? to : to.pathname);
  const matched = useMatch(url ?? '');
  const isActive = active ?? Boolean(matched);

  return (
    <Link
      {...otherProps}
      ref={ref}
      aria-current={isActive ? 'page' : undefined}
      className={classNames('link', 'text', type, className, variant, {
        disabled,
        active: isActive,
      })}
    />
  );
});

// Добавляем отображаемое имя для улучшения отладки
UDNavLink.displayName = 'UDNavLink';

export default UDNavLink;
